export default "__VITE_ASSET__zqo12riX__"